import api from "../api/api";

export default class McpAuthorizeApiService {
    async authorize(request: IMcpAuthorizeRequest): Promise<string> {
        try {
            const response = await api.post("/mcp/authorize", request);
            return response.data.redirectUrl;
        } catch (error: any) {
            throw new Error(error?.response?.data?.error);
        }
    }
}

export interface IMcpAuthorizeRequest {
    redirectUri: string;
    state: string;
    codeChallenge: string;
    codeChallengeMethod: string;
    nonce: string;
    scope: string;
    clientId: string;
}
